export default __webpack_public_path__ + "static/media/vaza_nagy.c0eefbb0.gltf";